import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import {gridMargin} from "./general";
import QuickbooksFuelItemContainer from "../../containers/billing/QuickbooksFuelItem";

class FMPQuickbooksFuelItemSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const {quickbooksFuelItems, searchQuickbooksFuelItems} = this.props;
		if (_.isEmpty(quickbooksFuelItems)) {
			searchQuickbooksFuelItems();
		}
	}

	render () {
		const {
			label, value, path, onChange,
			error, helpText, md, readOnly,
			quickbooksFuelItems,
			quickbooksItemMap,
			showOnlyFuelLineItems,
		} = this.props;

		if (!quickbooksFuelItems) {
			return (<Grid spacing={2} container>
				<Grid item xs={12} md={md}>
					<Select
						value={value}
						input={<Input id={path} readOnly={readOnly} />}
					>
						<MenuItem key={'loading mapped item freights'} value={'loading'} disabled>
							Loading mapped items for fuel...
						</MenuItem>
					</Select>
				</Grid>
			</Grid>);
		}


		const options = _.values(
			_.keyBy(quickbooksFuelItems, 'quickbooksItemId')
		).reduce((result, quickbooksFuelItem) => {
			const { quickbooksItemId, isFuelLineItem } = quickbooksFuelItem;
			if (showOnlyFuelLineItems && !isFuelLineItem) {
				return result;
			}

			if (!showOnlyFuelLineItems && isFuelLineItem) {
				return result;
			}

			const quickbooksItem = quickbooksItemMap[quickbooksItemId] || { Name : 'Missing'};
			result.push({
				value : quickbooksItemId,
				display : `${quickbooksItem.Name} - ${quickbooksItem.Description}`,
			});
			return result;
		}, []);


		const hasError = !!error;
		const _onChange = event => {
			onChange(event.target.value, path);
		};

		return (<Grid spacing={2} container >
			<Grid item xs={12} md={md} style={gridMargin}>
				<FormControl fullWidth={true} error={hasError}>
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input id={path} readOnly={readOnly} />}
					>
						{_.sortBy(options, 'display').map(option => {
							const { display, value } = option;
							return (
								<MenuItem key={value} value={value}>
									{display}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		</Grid>);
	}
}

FMPQuickbooksFuelItemSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	searchQuickbooksFuelItems : PropTypes.func,
	quickbooksFuelItems : PropTypes.array,
	quickbooksItemMap : PropTypes.object,
	showOnlyFuelLineItems : PropTypes.bool,

	md : PropTypes.number,
	helpText : PropTypes.string,
	readOnly : PropTypes.bool,
};

FMPQuickbooksFuelItemSelect.defaultProps =  {
};

export default _.flow([
	QuickbooksFuelItemContainer,
])(FMPQuickbooksFuelItemSelect);
